import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { ContractPeriod } from 'src/common/interfaces';
import { getMstContractPeriod } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const ModalGuideContractPeriod = ({
  setIsOpen,
  onCallbackFunction,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onCallbackFunction: (item: ContractPeriod) => void;
}) => {
  const header = ['年数', '保守割引率', '利用料割引率'];
  const [dataContractPeriod, setDataContractPeriod] = useState<Array<ContractPeriod>>([]);

  const [searchContractPeriod, { data: contractPeriod, loading: isContractPeriodLoading }] = useAppLazyQuery({
    query: gql(getMstContractPeriod),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onClickItemContractPeriod = (contractPeriod: ContractPeriod) => {
    onCallbackFunction(contractPeriod);
    setIsOpen(false);
  };

  const renderTableData = useMemo(() => {
    if (dataContractPeriod?.length <= 0 || !dataContractPeriod) return;
    return dataContractPeriod.map((contractPeriod: ContractPeriod, index: number) => {
      return (
        <tr key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{contractPeriod?.mcp_years}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{contractPeriod?.mcp_maintenance_discount_rate}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p onClick={() => onClickItemContractPeriod(contractPeriod)}>
              {contractPeriod?.mcp_usage_fee_discount_rate}
            </p>
          </td>
        </tr>
      );
    });
  }, [dataContractPeriod]);

  useEffect(() => {
    const newContractPeriodData = { ...contractPeriod };
    const listContractPeriod: ContractPeriod[] =
      newContractPeriodData?.getMstContractPeriod?.sort((period1: any, period2: any) => {
        return period1.mcp_years - period2.mcp_years;
      }) || [];
    setDataContractPeriod(listContractPeriod);
  }, [contractPeriod]);

  useEffect(() => {
    searchContractPeriod({ variables: { input: {} } });
  }, []);

  return (
    <div className="fixed w-full h-full inset-0 flex items-center justify-center">
      <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
      <div className="flex fixed bg-white h-3/6 w-1/3 items-center flex-col z-[1] overflow-auto">
        <div className="w-5/6 flex justify-end items-center mt-[10px]">
          <button onClick={() => setIsOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
          <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]">
            <thead>
              <tr>{renderTableHeader()}</tr>
            </thead>
            <tbody>
              {isContractPeriodLoading ? (
                <tr>
                  <td
                    colSpan={header.length}
                    className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : (
                renderTableData
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ModalGuideContractPeriod;
